/**
 * Where an old `/webinars...` address of the operator app lives now that the place is called Rooms. Emails,
 * notifications and bookmarks carry the old addresses, so each one still lands on the same screen. The API keeps
 * its own `/webinars` paths; only the app's addresses moved.
 */
export function legacyRoomPath(pathname: string): string | null {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "webinars") return null;
  const rest = parts.slice(1);
  // The board used to sit at /webinars/new/board/:id; a room's board is /rooms/:id/walk now.
  if (rest[0] === "new") return rest[1] === "board" && rest[2] ? `/rooms/${rest[2]}/walk` : "/rooms/new";
  return ["/rooms", ...rest].join("/");
}
